import * as React from "react"
import { DecisionGraph } from "@imminently/decisively-core"
import GraphData from "@imminently/decisively-ui/GraphData"
import { ComponentPage, ComponentSection } from "../components/ComponentPage"

const nodes = new Map<string, any>([
  [
    "eligibility",
    {
      id: "eligibility",
      entity: "global",
      description: "Eligibility",
      derived: true,
    },
  ],
  [
    "premium",
    {
      id: "premium",
      entity: "global",
      description: "Premium",
      derived: 1234.56,
    },
  ],
  [
    "applicant-age",
    {
      id: "age",
      path: "applicant/0/age",
      entity: "applicant",
      description: "Age",
      input: 42,
    },
  ],
  [
    "applicant-income",
    {
      id: "income",
      path: "applicant/0/income",
      entity: "applicant",
      description: "Income",
      input: 84000,
    },
  ],
  [
    "applicant-risk",
    {
      id: "risk_band",
      path: "applicant/0/risk_band",
      entity: "applicant",
      description: "Risk band",
      derived: "medium",
      validation: { severity: "warning", message: "Manual review recommended" },
    },
  ],
])

/**
 * The mock nodes as a decision graph: entity attributes at their instance paths (with their rule node, hidden, as the
 * template a session graph has), the rest by id.
 */
const graph = (() => {
  const working = new DecisionGraph()
  for (const node of nodes.values()) {
    if (!node.path) continue
    const { path: _path, input: _input, derived: _derived, ...rule } = node
    working.setNode(working.createRef(node.id), { ...rule, hidden: true })
  }
  for (const node of nodes.values()) working.setNode(working.createRef(node.path ?? node.id), node)
  return DecisionGraph.from(working.toBytes())
})()

const release = {
  relationships: [
    {
      source: "global",
      target: "applicant",
      name: "applicant",
      containment: true,
    },
  ],
} as any

export function GraphDataPage() {
  return (
    <ComponentPage
      title="Graph Data"
      description="Tree and detail view for graph/session data, based on the monitor SDK DataTree examples."
    >
      <ComponentSection
        title="Debug tree"
        description="A compact mock graph with global and entity-instance attributes."
      >
        <div className="h-[34rem] overflow-hidden rounded-md border border-border">
          <GraphData graph={graph} release={release} debug />
        </div>
      </ComponentSection>
    </ComponentPage>
  )
}
